(function () {
  const root = document.querySelector("[data-nexus-header]");
  if (!root) return;

  const drawer = root.querySelector("[data-nexus-drawer]");
  const openBtn = root.querySelector("[data-nexus-menu-open]");
  const closeBtn = root.querySelector("[data-nexus-menu-close]");

  function openMenu() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeMenu() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = "";
  }

  if (openBtn) openBtn.addEventListener("click", openMenu);
  if (closeBtn) closeBtn.addEventListener("click", closeMenu);
  if (drawer) {
    drawer.addEventListener("click", function (event) {
      if (event.target === drawer) closeMenu();
    });
  }
})();
